<template>
  <div class="text-center">
    <vueper-slides
      ref="vueperslides1"
      @slide="
        $refs.vueperslides2 &&
          $refs.vueperslides2.goToSlide($event.currentSlide.index, {
            emit: false,
          })
      "
      slide-multiple
      class="no-shadow"
      :fixed-height="true"
      :arrows-outside="false"
      :bullets="false"
      :infinite="true"
      :dragging-distance="100"
      :touchable="true"
      :disable-arrows-on-edges="true"
      :visible-slides="1"
    >
      <vueper-slide v-for="(slide, i) in slides" :key="i">
        <template #content>
          
            <div class="talks__slide" v-html="slide.image"></div>
          </template
      ></vueper-slide>
    </vueper-slides>

    <vueper-slides
      ref="vueperslides2"
      class="no-shadow"
      :dragging-distance="50"
      :gap="2"
      @slide="
        $refs.vueperslides1 &&
          $refs.vueperslides1.goToSlide($event.currentSlide.index, {
            emit: false,
          })
      "
      :visible-slides="3"
      fixed-height="160px"
    >
      <vueper-slide
        v-for="(slide, i) in thumbs"
        :key="i"
        class="talks__thumb"
        :image="slide.image"
        @click.native="
          $refs.vueperslides2 && $refs.vueperslides2.goToSlide(i - 1)
        "
      >
        <template #content>
          <div></div>
        </template>
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "SliderVideo",
  inject: ["content"],
  data() {
    return {
      title: "SliderVideo",
      slides: [
        {
          image: `<iframe src="https://player.vimeo.com/video/807512604?h=f667345cb4&color=66cc00&title=0&byline=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
        },
        {
          image: `<iframe src="https://player.vimeo.com/video/805119866?h=127fff2a4e&color=ee562d&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
        },
        {
          image: `<iframe src="https://player.vimeo.com/video/809780023?h=b25828d4ed&color=e6780e&title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`,
        },
      ],
      thumbs: [
        {
          image: require("@/assets/images/slider_talks/talks_1.png"),
        },
        {
          image: require("@/assets/images/slider_talks/talks_2.png"),
        },
        {
          image: require("@/assets/images/slider_talks/talks_3.png"),
        },
      ],
    };
  },
  components: { VueperSlides, VueperSlide },
};
</script>
